
import React, { useState } from "react";
import "./navigation.css";
// Use public/external for static assets in React
const logo = process.env.PUBLIC_URL + "/external/pastedimage-h4t-200h.png";

export default function StickyNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState({});

  // Toggle main menu
  const toggleMenu = () => setMenuOpen((open) => !open);

  // Toggle dropdowns for mobile
  const handleDropdown = (key) => {
    setDropdownOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // Close menu on navigation (mobile)
  const handleNavClick = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <a className="navbar-brand d-flex align-items-center" href="/" onClick={handleNavClick}>
          <img src={logo} alt="Cysigil Logo" width="70" height="70" className="me-2 navigation-brand-img" />
          <span className="navigation-brand-text">Cysigil</span>
        </a>


        {/* Book a Meeting - right for desktop only */}
        <a
          className="btn book-meeting-btn desktop-only"
          href="https://outlook.office.com/book/CysigilNetwork@cysigil.com/?ismsaljsauthenabled"
          onClick={handleNavClick}
        >
          Book a Meeting
        </a>

        {/* Hamburger for mobile */}
        <button className="hamburger" aria-label="Toggle menu" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Main Menu */}
        <ul className={`menu${menuOpen ? " open" : ""}`}>
          <li className="menu-item" onClick={handleNavClick}><a href="/">Home</a></li>

          <li
            className={`menu-item dropdown${dropdownOpen.services ? " open" : ""}`}
            onClick={() => window.innerWidth <= 900 && handleDropdown("services")}
            onMouseEnter={() => window.innerWidth > 900 && setDropdownOpen((prev) => ({ ...prev, services: true }))}
            onMouseLeave={() => window.innerWidth > 900 && setDropdownOpen((prev) => ({ ...prev, services: false }))}
          >
            Services
            <div className="mega-menu">
              <div className="mega-column">
                <h5>SOC-as-a-Service</h5>
                <a href="/soc-as-a-service" onClick={handleNavClick}>Managed Security Services</a>
                <a href="/incident-response" onClick={handleNavClick}>Incident Response &amp; Management</a>
                <a href="/digital-forensics" onClick={handleNavClick}>Digital Forensics</a>
              </div>
              <div className="mega-column">
                <h5>VAPT-as-a-Service</h5>
                <a href="/web-application-security" onClick={handleNavClick}>Web Application Security</a>
                <a href="/api-security-testing" onClick={handleNavClick}>API Security Testing</a>
                <a href="/mobile-application-security" onClick={handleNavClick}>Mobile Application Security</a>
                <a href="/network-security-testing" onClick={handleNavClick}>Network Security Testing</a>
                <a href="/firewall-configuration-review" onClick={handleNavClick}>Firewall Configuration Review</a>
                <a href="/source-code-review" onClick={handleNavClick}>Source Code Review</a>
                <a href="/thick-client-application-security" onClick={handleNavClick}>Thick Client Security</a>
                <a href="/blockchain-security" onClick={handleNavClick}>Blockchain Security</a>
                <a href="/llm-penetration-testing" onClick={handleNavClick}>LLM Penetration Testing</a>
              </div>
              <div className="mega-column">
                <h5>Additional Services</h5>
                <a href="/io-t-security" onClick={handleNavClick}>IoT Security</a>
                <a href="/ot-security" onClick={handleNavClick}>OT Security</a>
                <a href="/cloud-security-assessment" onClick={handleNavClick}>Cloud Security Assessment</a>
                <a href="/application-security-dev-sec-ops1" onClick={handleNavClick}>DevSecOps</a>
                <a href="/red-team-exercises" onClick={handleNavClick}>Red Team Exercise</a>
              </div>
            </div>
          </li>

          <li
            className={`menu-item dropdown${dropdownOpen.consulting ? " open" : ""}`}
            onClick={() => window.innerWidth <= 900 && handleDropdown("consulting")}
            onMouseEnter={() => window.innerWidth > 900 && setDropdownOpen((prev) => ({ ...prev, consulting: true }))}
            onMouseLeave={() => window.innerWidth > 900 && setDropdownOpen((prev) => ({ ...prev, consulting: false }))}
          >
            Consulting
            <div className="mega-menu-consulting">
              <div className="mega-column-consulting">
                <a href="/v-ciso-services" onClick={handleNavClick}>vCISO</a>
                <div className="submenu-parent">
                  <span className="menu-label">Security Compliance &amp; Assessments</span>
                  <div className="submenu-right">
                    <a href="/soc-compliance" onClick={handleNavClick}>SOC Compliance</a>
                    <a href="/pci-dss-compliance" onClick={handleNavClick}>PCI-DSS Compliance</a>
                  </div>
                </div>
                <a href="/vendor-risk-management" onClick={handleNavClick}>Vendor Risk Management</a>
                <a href="/operational-resilience" onClick={handleNavClick}>Operational Resilience</a>
                <a href="/cyber-governance-advisory" onClick={handleNavClick}>Cyber Governance Advisory</a>
              </div>
              <div className="mega-column-consulting">
                <a href="/iso-standards-ai-grc-ai-governance-risk-compliance" onClick={handleNavClick}>ISO Standard Services</a>
                <a href="/data-protection-privacy" onClick={handleNavClick}>Data Protection &amp; Privacy</a>
                <a href="/internal-controls-design-testing" onClick={handleNavClick}>Internal Controls Design &amp; Testing</a>
                <a href="/ai-governance-risk-compliance-ai-grc" onClick={handleNavClick}>AI Governance, Risk &amp; Compliance</a>
              </div>
            </div>
          </li>

          <li
            className={`menu-item dropdown${dropdownOpen.company ? " open" : ""}`}
            onClick={() => window.innerWidth <= 900 && handleDropdown("company")}
            onMouseEnter={() => window.innerWidth > 900 && setDropdownOpen((prev) => ({ ...prev, company: true }))}
            onMouseLeave={() => window.innerWidth > 900 && setDropdownOpen((prev) => ({ ...prev, company: false }))}
          >
            Company
            <div className="mega-menu-company">
              <div className="mega-column">
                <a href="/about-us" onClick={handleNavClick}>About Us</a>
                <a href="/contact-us" onClick={handleNavClick}>Contact Us</a>
                {/* <a href="/case-studies">Case Studies</a> */}
                <a href="/blog" onClick={handleNavClick}>Blog</a>
              </div>
            </div>
          </li>

          {/* Book a Meeting - inside menu for mobile only */}
          <li className="menu-item mobile-only">
            <a
              className="btn book-meeting-btn"
              href="https://outlook.office.com/book/CysigilNetwork@cysigil.com/?ismsaljsauthenabled"
              onClick={handleNavClick}
            >
              Book a Meeting
            </a>
          </li>
        </ul>

        {/* Right Action (removed, now above) */}
      </div>
    </nav>
  );
}
